module.exports = __webpack_public_path__ + "static/media/modis2980.422fffd7.jpg";